const IS_TENANT =
  window.location.host !== process.env.REACT_APP_ACME_LOCAL_HOST &&
  window.location.host !== process.env.REACT_APP_ACME_STAGING_HOST &&
  window.location.host !== process.env.REACT_APP_LOCAL_HOST &&
  window.location.host !== process.env.REACT_APP_STAGING_HOST &&
  window.location.host !== process.env.REACT_APP_PRODUCTION_HOST &&
  window.location.host !== process.env.REACT_APP_XPO_STAGING_HOST &&
  window.location.host !== process.env.REACT_APP_XPO_PRODUCTION_HOST &&
  window.location.host !== process.env.REACT_APP_RPT_STAGING_HOST &&
  window.location.host !== process.env.REACT_APP_RPT_PRODUCTION_HOST &&
  window.location.host !== process.env.REACT_APP_ONTIME_STAGING_HOST &&
  window.location.host !== process.env.REACT_APP_ONTIME_PRODUCTION_HOST &&
  window.location.host !== process.env.REACT_APP_ALIANZA_STAGING_HOST &&
  window.location.host !== process.env.REACT_APP_ALIANZA_PRODUCTION_HOST &&
  process.env.REACT_APP_LOCAL_HOST !== undefined;

const SERVICES = {
  INSPECTLET: true,
  DOCUMENTATION: !IS_TENANT,
  SEGMENT: !IS_TENANT,
  ZENDESK: !IS_TENANT,
};

const FEATURES = {
  COPY_SO_ID: !IS_TENANT,
  IS_LH_FILTER_ENABLED: !IS_TENANT,
};

export { IS_TENANT, SERVICES, FEATURES };
